var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserRemoveFilled = function SvgUserRemoveFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a6 6 0 1 1 12 0A6 6 0 0 1 3 6m6 8a9.01 9.01 0 0 0-9 9 1 1 0 0 0 1 1h16a1 1 0 0 0 1-1 9.01 9.01 0 0 0-9-9m12.414-2 2.293-2.293a1 1 0 0 0-1.414-1.414L20 10.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L18.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L20 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414z"
  })));
};
export default SvgUserRemoveFilled;